var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasGetterSet == false && _vm.toparticle.length > 0
      ? _c(
          "div",
          { staticClass: "widget widget-item-list widget-primary topitems" },
          [
            _c(
              "div",
              { staticClass: "widget-inner" },
              [
                _c("div", { staticClass: "h3" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$translate("Phywe::Template.topitemsHeadline", {
                          categoryname: _vm.categorydetails
                        })
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "carousel",
                  {
                    staticClass: "my-carousel",
                    attrs: { "items-per-page": 5 }
                  },
                  [
                    _vm._l(_vm.topitems, function(topitem) {
                      return _c(
                        "template",
                        { slot: "items" },
                        [
                          _c("category-item", {
                            attrs: {
                              "item-data": topitem.more.data,
                              "decimal-count":
                                _vm.$ceres.config.item.storeSpecial,
                              "disable-carousel-on-mobile": true
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }